<template>
  <el-form ref="form" :model="data" label-width="100px">
    <el-form-item label="管理员账号" prop="name">
      <el-input v-model.trim="name" readonly />
    </el-form-item>

    <el-form-item label="分组" prop="access">
      <el-tree
        ref="tree"
        class="admin-access"
        :props="props"
        :data="list"
        show-checkbox
        node-key="id"
        :highlight-current="true"
        :default-expand-all="true"
        :expand-on-click-node="false"
        :check-strictly="true"
        @check-change="treeCheck"
      />
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submit">{{ '提交' }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {
  getDetail as getAdminDetail,
  updateAccess as updateAdminAccess
} from '@/api/admin'
import { getGroupTreeList } from '@/api/authGroup'

export default {
  name: 'AdminAccess',
  components: { },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      name: '',
      data: {
        id: '',
        groups: ''
      },
      props: {
        label: 'title'
      },
      list: [],
      checkedids: ''
    }
  },
  watch: {
    item: {
      handler(val, oldVal) {
        if (this.item.dialogVisible === true && this.data.id !== oldVal.id) {
          this.data.id = val.id
          this.name = val.name
          this.featchData()
        }
      },
      deep: true
    }
  },
  created() {
    this.data.id = this.item.id
    this.name = this.item.name
    this.featchData()
  },
  methods: {
    async featchData() {
      await this.fetchGroups()

      await this.fetchAdminDetail()
    },
    fetchAdminDetail() {
      return getAdminDetail(this.data.id).then(response => {
        const groups = response.data.groups
        if (groups.length > 0) {
          groups.forEach(item => {
            const node = this.$refs.tree.getNode(item.id)
            this.$refs.tree.setChecked(node, true)
          })
        }
      })
    },
    fetchGroups() {
      return getGroupTreeList().then((res) => {
        this.list = res.data.list
      })
    },
    treeCheck() {
      const checkedKeys = this.$refs.tree.getCheckedKeys()
      this.checkedids = checkedKeys.join(',')
      this.data.groups = this.checkedids
    },
    submit() {
      updateAdminAccess(this.data).then(response => {
        this.item.dialogVisible = false
        this.$message({
          message: '账号授权成功',
          type: 'success',
          duration: 2 * 1000,
          onClose() {
            if (this.$refs.form !== undefined) {
              this.$refs.form.resetFields()
            }
            this.item.dialogVisible = false
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.admin-access {
  background-color: #FFFFFF;
  background-image: none;
  border-radius: 5px;
  border: 1px solid #DCDFE6;
  padding: 8px 5px;
}
</style>
